import { PortalPartnerTypeEnum } from '@routellers/types/dist/partners-portal/enum/portal-partner-type.enum';
import { Center, Loader, Stack, Text, Button } from '@mantine/core';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { AppLayout } from './components/app-layout';
import { AuthLayout } from './components/auth-layout';
import { DashboardPage } from './pages/dashboard';
import { EarningsPage } from './pages/earnings';
import { ForgotPasswordPage } from './pages/forgot-password';
import { LoginPage } from './pages/login';
import { RegisterPage } from './pages/register';
import { SettingsPage } from './pages/settings';
import { RouteEditorPage } from './pages/route-editor';
import { RoutesPage } from './pages/routes';
import { StoriesPage } from './pages/stories';
import { StoryEditorPage } from './pages/story-editor';
import { VerifyEmailPage } from './pages/verify-email';
import { useAuth } from './providers/auth-context';

const RedirectStoryToQuest = () => {
    const { id } = useParams();

    return <Navigate to={id ? `/quests/${id}` : '/quests'} replace />;
};

export const App = () => {
    const { partner, initializing, logout } = useAuth();

    if (initializing) {
        return (
            <Center h='100vh'>
                <Loader />
            </Center>
        );
    }

    if (!partner) {
        return (
            <Routes>
                <Route element={<AuthLayout />}>
                    <Route path='/login' element={<LoginPage />} />
                    <Route path='/register' element={<RegisterPage />} />
                    <Route path='/verify' element={<VerifyEmailPage />} />
                    <Route path='/forgot-password' element={<ForgotPasswordPage />} />
                </Route>
                <Route path='*' element={<Navigate to='/login' replace />} />
            </Routes>
        );
    }

    if (partner.type !== PortalPartnerTypeEnum.AUTHOR) {
        return (
            <Center h='100vh' px='md'>
                <Stack align='center' gap='md' maw={420}>
                    <Text ta='center'>
                        Venue accounts use the venues cabinet. Please sign in at
                        venues.routellers.com.
                    </Text>
                    <Button variant='light' onClick={() => void logout()}>
                        Sign out
                    </Button>
                </Stack>
            </Center>
        );
    }

    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route path='/' element={<DashboardPage />} />
                <Route path='/quests' element={<StoriesPage />} />
                <Route path='/quests/new' element={<StoryEditorPage />} />
                <Route path='/quests/:id' element={<StoryEditorPage />} />
                <Route path='/stories' element={<Navigate to='/quests' replace />} />
                <Route path='/stories/new' element={<Navigate to='/quests/new' replace />} />
                <Route path='/stories/:id' element={<RedirectStoryToQuest />} />
                <Route path='/routes' element={<RoutesPage />} />
                <Route path='/routes/new' element={<RouteEditorPage />} />
                <Route path='/routes/:id' element={<RouteEditorPage />} />
                <Route path='/earnings' element={<EarningsPage />} />
                <Route path='/settings' element={<SettingsPage />} />
            </Route>
            <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
    );
};
